import { render } from "./CompanySubmissionCell.vue?vue&type=template&id=2fcebc78&ts=true"
import script from "./CompanySubmissionCell.vue?vue&type=script&lang=ts"
export * from "./CompanySubmissionCell.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__